import { createStore } from "vuex";
import Documentation, {
  DocumentationId,
  Group,
  Submission,
} from "../entities/documentation";
import { DocumentationGroup as ApiDocGroup } from "../services/documentation-group-service";
import { documentationGroupService } from "./../services/index";
import { submissionService } from "@/services";
import { toSubmission } from "@/services/documentation-submission-service";
import { authUserModule, ModuleState as AuthUserState } from "./auth-user";
import { MessageModule, ModuleState as MessageState } from "./message";
type GroupId = number;
export default createStore<State>({
  state: {
    documentationGroups: new Map(),
    submissions: new Map(),
    documentations: new Map(),
  },
  mutations: {
    setNewGroups(state: State): void {
      state.documentationGroups = new Map();
      state.documentations = new Map();
    },
    setGroup(state: State, payload: SetGroupPayload): void {
      state.documentationGroups.set(payload.id, payload.value);
    },
    removeGroup(state: State, id: GroupId): void {
      state.documentationGroups.delete(id);
    },
    setNewSubmissions(state: State): void {
      state.submissions = new Map();
    },
    setSubmission(state: State, payload: SetSubmissionPayload): void {
      state.submissions.set(payload.id, payload.value);
    },
    removeSubmission(state: State, id: number): void {
      state.submissions.delete(id);
    },
    setDocumentations(
      state: State,
      iter: IterableIterator<[number, Documentation]>
    ) {
      for (const [key, value] of iter) {
        state.documentations.set(key, value);
      }
    },
  },
  actions: {
    async getAllGroups({ commit }) {
      const pageIter = documentationGroupService.getAllDocumentationGroups();
      commit("setNewGroups");
      for await (const page of pageIter) {
        page?.forEach((apiGroup: ApiDocGroup) => {
          const documentsMap: Map<DocumentationId, Documentation> = new Map(
            apiGroup.documentations.map((apiDoc) => [
              apiDoc.id,
              new Documentation({ group: null, ...apiDoc }),
            ])
          );
          commit("setDocumentations", documentsMap.entries());
          const group = new Group({
            ...apiGroup,
            documentations: documentsMap,
          });
          commit("setGroup", { id: group.id, value: group });
        });
      }
    },
    async getSubmission({ commit }, payload: { id: number }) {
      const submissionDTO = (await submissionService.getSubmission(payload))
        .data;
      const submission = toSubmission(submissionDTO);
      commit("setSubmission", { id: submissionDTO.id, value: submission });
    },
  },
  modules: {
    authUser: authUserModule,
    msg: MessageModule,
  },
});

export interface State {
  documentationGroups: Map<GroupId, Group>;
  documentations: Map<number, Documentation>;
  submissions: Map<number, Submission>;
  authUser?: AuthUserState;
  msg?: MessageState;
}
interface SetGroupPayload {
  id: GroupId;
  value: Group;
}
interface SetSubmissionPayload {
  id: number;
  value: Submission;
}
